import SI from "./enum.js";

const alert = (
	state = {
		alerts: [],
		authPopupOpen: false,
		authType: null,
		staticWarning: null,
	},
	action
) => {
	switch (action.type) {
		case SI.TOGGLE_AUTH_POPUP:
			return {
				...state,
				authPopupOpen: action.payload.isOpen,
				authType: action.payload.authType,
				...(action.payload.isOpen ? { alerts: [] } : null),
			};
		case SI.ALERT_IN:
			return {
				...state,
				alerts: [...state.alerts, action.payload],
			};
		case SI.ALERT_OUT:
			return {
				...state,
				alerts: state.alerts.filter((_, alertIndex) => alertIndex !== action.payload),
			};
		case SI.SET_STATIC_WARNING: {
			const incomingPriority = action.payload?.priority ?? 0;
			const currentPriority = state.staticWarning?.priority ?? 0;
			if (state.staticWarning && incomingPriority < currentPriority) {
				return state;
			}
			return {
				...state,
				staticWarning: action.payload,
			};
		}
		case SI.CLEAR_STATIC_WARNING: {
			const clearPriority = action.payload?.priority;
			const currentPriority = state.staticWarning?.priority ?? 0;
			if (clearPriority !== undefined && clearPriority < currentPriority) {
				return state;
			}
			return {
				...state,
				staticWarning: null,
			};
		}
		default:
			return { ...state };
	}
};

export default alert;
